const majors = [
  {
    location: "Bologna '25",
    masters: 1239,
    results: [
      {
        top: 16,
        points: 26,
        in: 2,
        out: 6,
      },
      {
        top: 16,
        points: 27,
        in: 2,
        out: 3,
      },
      {
        top: 32,
        points: 26,
        in: 13,
        out: 4,
      },
      {
        top: 64,
        points: 24,
        in: 8,
        out: 6,
      },
      {
        top: 128,
        points: 22,
        in: 27,
        out: 9,
      },
      {
        top: 256,
        points: 14,
        in: 5,
        out: 72,
      },
      {
        top: 512,
        points: 12,
        in: 49,
        out: 34,
      },
    ],
  },
  {
    location: "Johannesburg '25",
    masters: 94,
    results: [
      {
        top: 8,
        points: 17,
        in: 2,
        out: 0,
      },
      {
        top: 16,
        points: 14,
        in: 3,
        out: 4,
      },
      {
        top: 32,
        points: 11,
        in: 1,
        out: 0,
      },
    ],
  },
  {
    location: "Portland '25",
    masters: 1688,
    results: [
      {
        top: 8,
        points: 29,
        in: 3,
        out: 6,
      },
      {
        top: 16,
        points: 28,
        in: 2,
        out: 8,
      },
      {
        top: 32,
        points: 27,
        in: 8,
        out: 2,
      },
      {
        top: 64,
        points: 25,
        in: 4,
        out: 25,
      },
      {
        top: 128,
        points: 23,
        in: 23,
        out: 20,
      },
      {
        top: 256,
        points: 19,
        in: 5,
        out: 15,
      },
      {
        top: 512,
        points: 13,
        in: 88,
        out: 67,
      },
    ],
  },
  {
    location: "Santiago '25",
    masters: 1249,
    results: [
      {
        top: 8,
        points: 28,
        in: 1,
        out: 4,
      },
      {
        top: 16,
        points: 27,
        in: 4,
        out: 2,
      },
      {
        top: 32,
        points: 26,
        in: 14,
        out: 3,
      },
      {
        top: 64,
        points: 24,
        in: 8,
        out: 7,
      },
      {
        top: 128,
        points: 21,
        in: 2,
        out: 18,
      },
      {
        top: 256,
        points: 14,
        in: 23,
        out: 55,
      },
      {
        top: 512,
        points: 12,
        in: 55,
        out: 37,
      },
    ],
  },
  {
    location: "Utrecht '25",
    masters: 1241,
    results: [
      {
        top: 8,
        points: 29,
        in: 3,
        out: 0,
      },
      {
        top: 16,
        points: 28,
        in: 8,
        out: 2,
      },
      {
        top: 32,
        points: 26,
        in: 9,
        out: 7,
      },
      {
        top: 64,
        points: 25,
        in: 25,
        out: 3,
      },
      {
        top: 128,
        points: 22,
        in: 19,
        out: 17,
      },
      {
        top: 256,
        points: 15,
        in: 40,
        out: 14,
      },
      {
        top: 512,
        points: 12,
        in: 57,
        out: 38,
      },
    ],
  },
  {
    location: "Melbourne  '25",
    masters: 563,
    results: [
      {
        top: 8,
        points: 26,
        in: 4,
        out: 3,
      },
      {
        top: 16,
        points: 25,
        in: 5,
        out: 0,
      },
      {
        top: 32,
        points: 23,
        in: 9,
        out: 3,
      },
      {
        top: 64,
        points: 20,
        in: 5,
        out: 8,
      },
      {
        top: 128,
        points: 14,
        in: 8,
        out: 23,
      },
      {
        top: 256,
        points: 11,
        in: 3,
        out: 28,
      },
    ],
  },
  {
    location: "Milwaukee  '25",
    masters: 1657,
    results: [
      {
        top: 8,
        points: 29,
        in: 3,
        out: 6,
      },
      {
        top: 16,
        points: 28,
        in: 2,
        out: 12,
      },
      {
        top: 32,
        points: 27,
        in: 4,
        out: 5,
      },
      {
        top: 64,
        points: 25,
        in: 10,
        out: 27,
      },
      {
        top: 128,
        points: 23,
        in: 10,
        out: 22,
      },
      {
        top: 256,
        points: 19,
        in: 11,
        out: 7,
      },
      {
        top: 512,
        points: 13,
        in: 88,
        out: 56,
      },
    ],
  },
  {
    location: "Seville  '25",
    masters: 817,
    results: [
      {
        top: 8,
        points: 26,
        in: 4,
        out: 2,
      },
      {
        top: 16,
        points: 25,
        in: 6,
        out: 4,
      },
      {
        top: 32,
        points: 23,
        in: 3,
        out: 11,
      },
      {
        top: 64,
        points: 22,
        in: 21,
        out: 6,
      },
      {
        top: 128,
        points: 17,
        in: 2,
        out: 0,
      },
      {
        top: 256,
        points: 13,
        in: 42,
        out: 36,
      },
    ],
  },
  {
    location: "Johannesburg '25",
    masters: 85,
    results: [
      {
        top: 8,
        points: 17,
        in: 5,
        out: 1,
      },
      {
        top: 16,
        points: 14,
        in: 3,
        out: 1,
      },
      {
        top: 32,
        points: 11,
        in: 4,
        out: 0,
      },
    ],
  },
  {
    location: "Monterrey  '25",
    masters: 1327,
    results: [
      {
        top: 8,
        points: 29,
        in: 5,
        out: 1,
      },
      {
        top: 16,
        points: 27,
        in: 1,
        out: 4,
      },
      {
        top: 32,
        points: 26,
        in: 12,
        out: 5,
      },
      {
        top: 64,
        points: 24,
        in: 7,
        out: 8,
      },
      {
        top: 128,
        points: 22,
        in: 26,
        out: 1,
      },
      {
        top: 256,
        points: 14,
        in: 6,
        out: 80,
      },
      {
        top: 512,
        points: 12,
        in: 29,
        out: 67,
      },
    ],
  },
  {
    location: "Atlanta '25",
    masters: 2684,
    results: [
      {
        top: 16,
        points: 32,
        in: 5,
        out: 1,
      },
      {
        top: 16,
        points: 31,
        in: 7,
        out: 5,
      },
      {
        top: 32,
        points: 30,
        in: 11,
        out: 1,
      },
      {
        top: 64,
        points: 28,
        in: 13,
        out: 19,
      },
      {
        top: 128,
        points: 26,
        in: 29,
        out: 12,
      },
      {
        top: 256,
        points: 21,
        in: 7,
        out: 0,
      },
      {
        top: 512,
        points: 16,
        in: 79,
        out: 130,
      },
      {
        top: 1024,
        points: 13,
        in: 148,
        out: 42,
      },
    ],
  },
  {
    location: "Brisbane '25",
    masters: 470,
    results: [
      {
        top: 8,
        points: 24,
        in: 3,
        out: 2,
      },
      {
        top: 16,
        points: 22,
        in: 5,
        out: 5,
      },
      {
        top: 32,
        points: 20,
        in: 1,
        out: 12,
      },
      {
        top: 64,
        points: 18,
        in: 5,
        out: 3,
      },
      {
        top: 128,
        points: 13,
        in: 6,
        out: 37,
      },
    ],
  },
  {
    location: "Stockholm '25",
    masters: 815,
    results: [
      {
        top: 8,
        points: 26,
        in: 4,
        out: 2,
      },
      {
        top: 16,
        points: 25,
        in: 6,
        out: 8,
      },
      {
        top: 32,
        points: 23,
        in: 1,
        out: 13,
      },
      {
        top: 64,
        points: 22,
        in: 19,
        out: 8,
      },
      {
        top: 128,
        points: 18,
        in: 1,
        out: 5,
      },
      {
        top: 256,
        points: 13,
        in: 36,
        out: 62,
      },
    ],
  },
  {
    location: "Vancouver '25",
    masters: 1314,
    results: [
      {
        top: 8,
        points: 29,
        in: 3,
        out: 4,
      },
      {
        top: 16,
        points: 28,
        in: 4,
        out: 5,
      },
      {
        top: 32,
        points: 27,
        in: 11,
        out: 0,
      },
      {
        top: 64,
        points: 25,
        in: 13,
        out: 5,
      },
      {
        top: 128,
        points: 22,
        in: 2,
        out: 23,
      },
      {
        top: 256,
        points: 15,
        in: 22,
        out: 39,
      },
      {
        top: 512,
        points: 12,
        in: 35,
        out: 46,
      },
    ],
  },
  {
    location: "Fortaleza '25",
    masters: 715,
    results: [
      {
        top: 8,
        points: 26,
        in: 6,
        out: 4,
      },
      {
        top: 16,
        points: 25,
        in: 4,
        out: 4,
      },
      {
        top: 32,
        points: 23,
        in: 9,
        out: 6,
      },
      {
        top: 64,
        points: 22,
        in: 26,
        out: 1,
      },
      {
        top: 128,
        points: 15,
        in: 5,
        out: 33,
      },
      {
        top: 256,
        points: 13,
        in: 60,
        out: 11,
      },
    ],
  },
  {
    location: "EUIC '25",
    masters: 3361,
    results: [
      {
        top: 8,
        points: 33,
        in: 4,
        out: 0,
      },
      {
        top: 16,
        points: 31,
        in: 2,
        out: 9,
      },
      {
        top: 32,
        points: 30,
        in: 7,
        out: 7,
      },
      {
        top: 64,
        points: 29,
        in: 25,
        out: 9,
      },
      {
        top: 128,
        points: 27,
        in: 16,
        out: 5,
      },
      {
        top: 256,
        points: 24,
        in: 25,
        out: 18,
      },
      {
        top: 512,
        points: 17,
        in: 32,
        out: 74,
      },
      {
        top: 1024,
        points: 15,
        in: 171,
        out: 38,
      },
    ],
  },
  {
    location: "Puerto Rico '25",
    masters: 299,
    results: [
      {
        top: 8,
        points: 23,
        in: 5,
        out: 0,
      },
      {
        top: 16,
        points: 22,
        in: 8,
        out: 0,
      },
      {
        top: 32,
        points: 19,
        in: 6,
        out: 7,
      },
      {
        top: 64,
        points: 15,
        in: 12,
        out: 2,
      },
      {
        top: 128,
        points: 16,
        in: 9,
        out: 14,
      },
    ],
  },
  {
    location: "Merida '25",
    masters: 1151,
    results: [
      {
        top: 8,
        points: 28,
        in: 2,
        out: 6,
      },
      {
        top: 16,
        points: 27,
        in: 2,
        out: 5,
      },
      {
        top: 32,
        points: 26,
        in: 11,
        out: 4,
      },
      {
        top: 64,
        points: 23,
        in: 1,
        out: 31,
      },
      {
        top: 128,
        points: 21,
        in: 14,
        out: 1,
      },
      {
        top: 256,
        points: 14,
        in: 25,
        out: 47,
      },
      {
        top: 512,
        points: 11,
        in: 1,
        out: 88,
      },
    ],
  },
  {
    location: "San Antonio '25",
    masters: 2400,
    results: [
      {
        top: 8,
        points: 32,
        in: 3,
        out: 3,
      },
      {
        top: 16,
        points: 31,
        in: 5,
        out: 7,
      },
      {
        top: 32,
        points: 30,
        in: 9,
        out: 3,
      },
      {
        top: 64,
        points: 28,
        in: 17,
        out: 17,
      },
      {
        top: 128,
        points: 26,
        in: 30,
        out: 2,
      },
      {
        top: 256,
        points: 18,
        in: 6,
        out: 67,
      },
      {
        top: 512,
        points: 16,
        in: 106,
        out: 74,
      },
      {
        top: 1024,
        points: 12,
        in: 67,
        out: 69,
      },
    ],
  },
  {
    location: "Rio de Janeiro '25",
    masters: 1139,
    results: [
      {
        top: 8,
        points: 29,
        in: 2,
        out: 2,
      },
      {
        top: 16,
        points: 27,
        in: 2,
        out: 3,
      },
      {
        top: 32,
        points: 26,
        in: 13,
        out: 7,
      },
      {
        top: 64,
        points: 24,
        in: 5,
        out: 5,
      },
      {
        top: 128,
        points: 22,
        in: 33,
        out: 3,
      },
      {
        top: 256,
        points: 14,
        in: 7,
        out: 46,
      },
      {
        top: 512,
        points: 12,
        in: 83,
        out: 8,
      },
    ],
  },
  {
    location: "Birmingham '25",
    masters: 2018,
    results: [
      {
        top: 8,
        points: 30,
        in: 5,
        out: 1,
      },
      {
        top: 16,
        points: 28,
        in: 4,
        out: 14,
      },
      {
        top: 32,
        points: 27,
        in: 2,
        out: 16,
      },
      {
        top: 64,
        points: 26,
        in: 16,
        out: 3,
      },
      {
        top: 128,
        points: 24,
        in: 16,
        out: 19,
      },
      {
        top: 256,
        points: 21,
        in: 25,
        out: 9,
      },
      {
        top: 512,
        points: 14,
        in: 54,
        out: 27,
      },
    ],
  },
  {
    location: "Toronto '25",
    masters: 2137,
    results: [
      {
        top: 8,
        points: 32,
        in: 2,
        out: 4,
      },
      {
        top: 16,
        points: 31,
        in: 4,
        out: 3,
      },
      {
        top: 32,
        points: 29,
        in: 3,
        out: 11,
      },
      {
        top: 64,
        points: 28,
        in: 21,
        out: 5,
      },
      {
        top: 128,
        points: 25,
        in: 9,
        out: 27,
      },
      {
        top: 256,
        points: 18,
        in: 31,
        out: 38,
      },
      {
        top: 512,
        points: 16,
        in: 144,
        out: 30,
      },
      {
        top: 1024,
        points: 12,
        in: 117,
        out: 19,
      },
    ],
  },
  {
    location: "Stuttgart '25",
    masters: 1702,
    results: [
      {
        top: 8,
        points: 29,
        in: 2,
        out: 0,
      },
      {
        top: 16,
        points: 28,
        in: 8,
        out: 12,
      },
      {
        top: 32,
        points: 27,
        in: 4,
        out: 9,
      },
      {
        top: 64,
        points: 25,
        in: 9,
        out: 32,
      },
      {
        top: 128,
        points: 23,
        in: 13,
        out: 23,
      },
      {
        top: 256,
        points: 20,
        in: 44,
        out: 4,
      },
      {
        top: 512,
        points: 13,
        in: 66,
        out: 106,
      },
    ],
  },
  {
    location: "Perth '25",
    masters: 318,
    results: [
      {
        top: 8,
        points: 23,
        in: 2,
        out: 2,
      },
      {
        top: 16,
        points: 22,
        in: 6,
        out: 1,
      },
      {
        top: 32,
        points: 19,
        in: 1,
        out: 13,
      },
      {
        top: 64,
        points: 15,
        in: 9,
        out: 11,
      },
      {
        top: 128,
        points: 12,
        in: 7,
        out: 20,
      },
    ],
  },
  {
    location: "Bogota '25",
    masters: 225,
    results: [
      {
        top: 8,
        points: 20,
        in: 4,
        out: 1,
      },
      {
        top: 16,
        points: 18,
        in: 1,
        out: 5,
      },
      {
        top: 32,
        points: 17,
        in: 11,
        out: 1,
      },
      {
        top: 64,
        points: 12,
        in: 7,
        out: 7,
      },
    ],
  },
  {
    location: "Sacramento '25",
    masters: 1705,
    results: [
      {
        top: 8,
        points: 30,
        in: 3,
        out: 1,
      },
      {
        top: 16,
        points: 28,
        in: 5,
        out: 15,
      },
      {
        top: 32,
        points: 27,
        in: 2,
        out: 10,
      },
      {
        top: 64,
        points: 25,
        in: 9,
        out: 36,
      },
      {
        top: 128,
        points: 23,
        in: 7,
        out: 23,
      },
      {
        top: 256,
        points: 19,
        in: 5,
        out: 22,
      },
      {
        top: 512,
        points: 13,
        in: 71,
        out: 99,
      },
    ],
  },
  {
    location: "Gdansk '25",
    masters: 1372,
    results: [
      {
        top: 8,
        points: 30,
        in: 3,
        out: 0,
      },
      {
        top: 16,
        points: 28,
        in: 6,
        out: 7,
      },
      {
        top: 32,
        points: 27,
        in: 9,
        out: 2,
      },
      {
        top: 64,
        points: 24,
        in: 3,
        out: 14,
      },
      {
        top: 128,
        points: 17,
        in: 11,
        out: 8,
      },
      {
        top: 256,
        points: 15,
        in: 46,
        out: 88,
      },
      {
        top: 512,
        points: 12,
        in: 2,
        out: 145,
      },
    ],
  },
  {
    location: "Baltimore '25",
    masters: 2307,
    results: [
      {
        top: 8,
        points: 33,
        in: 2,
        out: 2,
      },
      {
        top: 16,
        points: 31,
        in: 3,
        out: 4,
      },
      {
        top: 32,
        points: 30,
        in: 12,
        out: 9,
      },
      {
        top: 64,
        points: 27,
        in: 3,
        out: 24,
      },
      {
        top: 128,
        points: 22,
        in: 8,
        out: 1,
      },
      {
        top: 256,
        points: 18,
        in: 48,
        out: 118,
      },
      {
        top: 512,
        points: 16,
        in: 101,
        out: 9,
      },
      {
        top: 1024,
        points: 12,
        in: 113,
        out: 103,
      },
    ],
  },
  {
    location: "Dortmund '25",
    masters: 1815,
    results: [
      {
        top: 8,
        points: 30,
        in: 2,
        out: 4,
      },
      {
        top: 16,
        points: 29,
        in: 4,
        out: 0,
      },
      {
        top: 32,
        points: 27,
        in: 3,
        out: 19,
      },
      {
        top: 64,
        points: 25,
        in: 8,
        out: 14,
      },
      {
        top: 128,
        points: 22,
        in: 12,
        out: 4,
      },
      {
        top: 256,
        points: 16,
        in: 74,
        out: 19,
      },
      {
        top: 512,
        points: 13,
        in: 5,
        out: 141,
      },
    ],
  },
  {
    location: "Joinville '25",
    masters: 578,
    results: [
      {
        top: 8,
        points: 27,
        in: 4,
        out: 1,
      },
      {
        top: 16,
        points: 24,
        in: 4,
        out: 6,
      },
      {
        top: 32,
        points: 23,
        in: 10,
        out: 1,
      },
      {
        top: 64,
        points: 16,
        in: 4,
        out: 28,
      },
      {
        top: 128,
        points: 15,
        in: 37,
        out: 23,
      },
      {
        top: 256,
        points: 12,
        in: 43,
        out: 25,
      },
    ],
  },
  {
    location: "Lima '25",
    masters: 307,
    results: [
      {
        top: 8,
        points: 23,
        in: 2,
        out: 0,
      },
      {
        top: 16,
        points: 21,
        in: 5,
        out: 1,
      },
      {
        top: 32,
        points: 16,
        in: 4,
        out: 6,
      },
      {
        top: 64,
        points: 14,
        in: 4,
        out: 12,
      },
      {
        top: 128,
        points: 12,
        in: 16,
        out: 13,
      },
    ],
  },
  {
    location: "Louisville '25",
    masters: 1938,
    results: [
      {
        top: 8,
        points: 31,
        in: 8,
        out: 0,
      },
      {
        top: 16,
        points: 30,
        in: 8,
        out: 2,
      },
      {
        top: 32,
        points: 28,
        in: 10,
        out: 1,
      },
      {
        top: 64,
        points: 26,
        in: 2,
        out: 5,
      },
      {
        top: 128,
        points: 24,
        in: 34,
        out: 1,
      },
      {
        top: 256,
        points: 16,
        in: 47,
        out: 26,
      },
      {
        top: 512,
        points: 14,
        in: 16,
        out: 18,
      },
    ],
  },
  {
    location: "Lille '25",
    masters: 1311,
    results: [
      {
        top: 8,
        points: 30,
        in: 4,
        out: 1,
      },
      {
        top: 16,
        points: 28,
        in: 3,
        out: 4,
      },
      {
        top: 32,
        points: 27,
        in: 12,
        out: 5,
      },
      {
        top: 64,
        points: 24,
        in: 4,
        out: 14,
      },
      {
        top: 128,
        points: 16,
        in: 2,
        out: 80,
      },
      {
        top: 256,
        points: 15,
        in: 48,
        out: 73,
      },
      {
        top: 512,
        points: 12,
        in: 21,
        out: 115,
      },
    ],
  },
];

majors.sort((a, b) => parseFloat(b.masters) - parseFloat(a.masters));

export default majors;
